<template>
  
  <div class="full-viewport">
    <img class="header-img" src="../../assets/navidad_banner.jpg" alt="Posada Anahuac Mayab 2023">
    <div class="container">
        <div class="content">
            <h1 class="title">
              Registro de Asistencia
            </h1>
            <p>
              Al enviar tu confirmación de asistencia, recibirás un correo electrónico con el código QR de acceso al evento.
            </p>
            <p>
              Preséntalo el día del evento al llegar para escanearlo y registrar tu asistencia.
            </p>
            <p>
              Si tienes alguna pregunta, contáctanos en 
              <a href="mailto:capitalhumanomayab@anahuac.mx">capitalhumanomayab@anahuac.mx</a>
            </p>
            <div class="row">
              <input type="checkbox" id="agreement" name="agreement" v-model="agreement"/>
              <label for="agreement">Entendido</label>
            </div>

            <input class="field" type="email" v-model="email" placeholder="correo@anahuac.mx">

            <button class="btn" type="button" @click="verifyEmail()">
              Enviar
            </button>
        </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'Posada2024',
    components: { },
    data () {
      return {
        email: '',
        agreement: false,
        basePath: process.env.VUE_APP_API_URL,
      }
    },
    methods: {
      isEmailValid(email) {
      const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return mailFormat.test(email);
      },
      async verifyEmail() {
        
        if(!this.agreement) {
          this.showDialog("Error",'Marca la casilla "Entendido" antes de enviar tu registro', "error");
          return;
        }
        
        this.showDialog("Verificando datos", "Estamos procesando tu solicitud, espere un momento...","info",false);
        if(!this.isEmailValid(this.email)) {
          this.showDialog("Error","El correo no cumple con la estructura requerida", "error");
          return;
        }

        var token = await this.$AuthApiService.getAccessToken();
        var response = await this.requestRegister(token);

        if(response.data.error) {
          this.showDialog("Error",response.data.error, "error");
          return;
        } else {
          this.showDialog("Registro exitoso", "Se ha registrado correctamente", "success");
          this.email = "";
          this.agreement = false;
        }

      },
      async requestRegister(token) {
      return this.$axios.post(this.basePath + 'api/external-events/register-participant',
        {
          "eventId": 63,
          "needValidation": true,
          "participants": [
            {
              "email": this.email,
              "assistants": 1,
              "guests": [
                {
                  "relationship": "personal",
                  "email": this.email
                }
              ]
            }
          ]
        }, 
        {
          headers: { 'Authorization': token.token_type + ' ' + token.access_token }
        }
        );
      },
      showDialog(title, msg, icon, showButton = true) {
        return this.$swal({
            title: title,
            text: msg,
            icon: icon,
            buttons: showButton
        });
      },
    }
  }
</script>